// Light / dark theme. The choice is remembered; first visit follows the device setting.
import { useEffect, useState } from 'react';

export const getTheme = () => (document.documentElement.dataset.theme === 'light' ? 'light' : 'dark');
export function setTheme(t) {
  document.documentElement.dataset.theme = t;
  try { localStorage.setItem('theme', t); } catch { /* ignore */ }
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', t === 'light' ? '#F5F7FA' : '#0A0D12');
  window.dispatchEvent(new CustomEvent('fx:theme', { detail: t }));
}
export function useTheme() {
  const [t, set] = useState(getTheme);
  useEffect(() => {
    const f = (e) => set(e.detail);
    window.addEventListener('fx:theme', f);
    return () => window.removeEventListener('fx:theme', f);
  }, []);
  return t;
}
